import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import PlaceHolder from "../../../assets/images/Placeholder.png";
import { Row, Col, Card, CardBody, CardTitle, CardText } from "reactstrap";
import "./LcaCards.css";
import moment from "moment-timezone";
import GitHubForkRibbon from "react-github-fork-ribbon";
import {
  setActionType,
  setSampleAd,
  setInquiryOpen,
  handleActionClick,
  checkExisting,
  setIsChatModalOpen,
  setShowCallDialog,
  setInquiryFullOpen,
} from "../../../redux/slices/SearchBarSlice";
import { setLoginPopUp } from "../../../redux/slices/settingSlice";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import OnlineStatus from "../../Layout/onlineStatus";
import { PopulateInquiry } from "./PopulateInquiry";
import CustomButton from "../../CustomButton";
import { FaCartPlus, FaCommentAlt, FaPhoneAlt } from "react-icons/fa";
const ActionButtons = ({
  card,
  isAdmin,
  phoneButton,
  handleAction,
  showMessageButton,
}) => {
  const navigate = useNavigate();
  let parsedPackages = [];
  try {
    if (card?.dealPackage) {
      parsedPackages = JSON.parse(card.dealPackage);
    }
  } catch (e) {
    console.warn("Failed to parse dealPackage:", e);
    parsedPackages = [];
  }
  const priorityPackage = parsedPackages.find((pkg) => pkg.isPriority === true);
  let displayPrice = null;
  if (priorityPackage?.totalPrice) {
    displayPrice = parseInt(priorityPackage.totalPrice, 10);
  } else if (parsedPackages.length > 0) {
    const prices = parsedPackages
      .map((p) => parseInt(p.totalPrice, 10) || 0)
      .filter(Boolean);
    displayPrice = prices.length > 0 ? Math.min(...prices) : null;
  }
  const priceText = displayPrice !== null ? `$${displayPrice}` : "BUY NOW";
  const handleBuyNow = (card) => {
    sessionStorage.setItem("scrollToPrices", "true");
    const Id = card.Id;
    navigate(`/vendordetails/${Id}`);
  };

  return (
    <>
      <div className="w-100 text-center need">
        <CustomButton
          onClick={(event) => handleAction(event, "CALL")}
          type="default"
          icon={FaPhoneAlt}
          title={phoneButton}
          className="w-100 mb-2"
        >
          {phoneButton}
        </CustomButton>
        {showMessageButton && (
          <CustomButton
            onClick={(e) => handleAction(e, "TEXT")}
            type="default"
            icon={FaCommentAlt}
            title="Send Message"
            className="w-100 mb-2"
          >
            Send Message
          </CustomButton>
        )}
        {!isAdmin && parsedPackages && parsedPackages.length > 0 && (
          <CustomButton
            onClick={(e) => {
              e.stopPropagation();
              handleBuyNow(card);
            }}
            type="yellow"
            icon={FaCartPlus}
            title="Add to Cart / BUY NOW"
            className="w-100"
          >
            {displayPrice !== null ? (
              <>
                BUY NOW <strong>{priceText}</strong>
              </>
            ) : (
              "BUY NOW"
            )}
          </CustomButton>
        )}
      </div>
    </>
  );
};
const BwvBox = ({ ad }) => {
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const { users: allUsers } = useSelector((state) => state.socket);
  const user = islogin ? JSON.parse(userinfo) : null;
  const [phoneButton, setPhoneButton] = useState("Show Phone Number");
  const [popupImage, setPopupImage] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    sampleAd,
    generatedNeedId,
    isChatModalOpen,
    actionClickStatus,
    actionClickError,
    checkExistingError,
    checkExistingStatus,
  } = useSelector((state) => state.searchBar);
  const isAdmin = user && user.Role === "admin";
  const isVendor = user && user.Role === "provider";
  const swiperRef = useRef(null);
  const { onlineView } = useSelector((state) => state.lcaAndVendors);
  const images =
    ad.Photo && JSON.parse(ad.Photo).length > 0
      ? JSON.parse(ad.Photo)
      : [PlaceHolder];

  useEffect(() => {
    if (actionClickStatus === "failed" && actionClickError) {
      toast.error(actionClickError);
    }
  }, [actionClickStatus, actionClickError]);

  useEffect(() => {
    if (ad.Id === generatedNeedId) {
      setPhoneButton(`${ad?.Phone || 0}`);
    }
  }, [generatedNeedId, sampleAd, ad.Id, ad.dialExtension]);

  useEffect(() => {
    if (checkExistingStatus === "failed" && checkExistingError) {
      toast.error(checkExistingError);
    }
  }, [checkExistingStatus, checkExistingError]);

  useEffect(() => {
    if (isAdmin || isVendor) {
      setPhoneButton(`${ad?.Phone || 0}`);
    }
  }, [isAdmin, isVendor, ad.dialExtension]);

  function convertTo12HourFormat(time24) {
    if (!time24) return "";
    const [hour24, minute] = time24.split(":").map(Number);
    if (isNaN(hour24) || isNaN(minute)) return "";
    const period = hour24 >= 12 ? "PM" : "AM";
    const hour12 = (hour24 % 12 || 12).toString().padStart(2, "0");
    return `${hour12}:${minute.toString().padStart(2, "0")} ${period}`;
  }

  function formatDate(inputDate) {
    let date = new Date(inputDate);
    let monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let year = date.getFullYear();
    let month = monthNames[date.getMonth()];
    let day = date.getDate();
    let formattedDay = day < 10 ? "0" + day : day;
    return `${month} ${formattedDay}, ${year}`;
  }

  function convertToUserTimezone(utcTime) {
    let timezone = "America/Los_Angeles";
    if (islogin && user?.TimeZone) {
      timezone = user?.TimeZone.split(",")[0];
    }
    const localTime = moment
      .utc(utcTime)
      .tz(timezone)
      .format("YYYY-MM-DD HH:mm:ss");
    return localTime;
  }

  const handleCardClick = (selectedCard) => {
    const screenWidth = window.innerWidth;
    const isIpadPro = screenWidth === 1024;
    let Id = selectedCard.Id;
    if (!isChatModalOpen) {
      // if (isIpadPro) {
      navigate(`/vendordetails/${Id}`);
      // } else {
      //   window.open(`#/vendordetails/${Id}`, "_blank");
      // }
    }
  };
const countdownFinished = useSelector((state) => state.session.countdownFinished);
  // const [countdownFinished, setCountdownFinished] = useState(false);
  const showMessageButton = islogin;
  // useEffect(() => {
  //   setCountdownFinished(false);
  //   const timer = setTimeout(() => {
  //     setCountdownFinished(true);
  //   }, 295 * 1000);
  //   return () => clearTimeout(timer);
  // }, []);
  const handleAction = async (event, action) => {
    event.stopPropagation();
    dispatch(setSampleAd(ad));
    dispatch(setActionType(action));
    if (!countdownFinished) {
      setPhoneButton(`${ad?.Phone || 0}`);
      if (action === "CALL") {
        dispatch(setShowCallDialog(true));
      } else if (action === "TEXT") {
        dispatch(setIsChatModalOpen(true));
      } else if (action === "VISIT") {
        window.open(ad?.websiteLink, "_blank");
      }
      return;
    }
    // If user is admin or vendor, show phone number and handle action directly
    if (isAdmin || isVendor) {
      setPhoneButton(`${ad?.Phone || 0}`);
      if (action === "CALL") {
        dispatch(setShowCallDialog(true));
      } else {
        dispatch(setIsChatModalOpen(true));
      }
      return;
    }
    // For non-admin/non-vendor users, check if the need exists
    let needExists = false;
    let enquiryData = null;
    let enquiryStep = null;
    if (islogin) {
      const constructedTitle = ad?.Title + " (Auto Generated)";
      const checkForm = {
        Title: constructedTitle,
        userId: user.UserID,
      };
      const result = await dispatch(checkExisting(checkForm)).unwrap();
      needExists = result?.data;
      enquiryData = result?.dataStep;
      enquiryStep = result?.dataStep?.enquiryStep;
    }
    // If need exists or user is logged in, handle the action
    if (needExists) {
      setPhoneButton(`${ad?.Phone || 0}`);
      if (action === "CALL") {
        dispatch(setShowCallDialog(true));
      } else {
        dispatch(setIsChatModalOpen(true));
      }
      return;
    }
    if (islogin) {
      const form = {
        userId: user.UserID,
        postId: ad.Id,
        postType: 2,
        clickType: action === "CALL" ? 1 : 2,
        createdBy: user.UserID,
      };
      dispatch(handleActionClick(form));
    }
    console.log(enquiryStep, "constructedTitle");
    if (enquiryStep > 0) {
      PopulateInquiry(enquiryData, dispatch);
    }
    // const isEnquirySent = localStorage.getItem("EnquirySent");
    if (enquiryStep >= 3 && islogin) {
      dispatch(setInquiryFullOpen(true));
    } else {
      dispatch(setInquiryOpen(true));
    }
  };

  return (
    <>
      <Card
        className="shadow-sm position-realtive d-block"
        style={{ backgroundColor: "transparent" }}
      >
        {ad?.caidStatus === 100 && (
          <GitHubForkRibbon
            color="green"
            position="left"
            className="absolute z-3 "
          >
            Verified & Trusted
          </GitHubForkRibbon>
        )}
        <Row className="g-0">
          <Col
            lg="3"
            md="3"
            className="d-flex align-items-center justify-content-center"
          >
            <div
              className="image-container"
              style={{
                width: "100%",
                height: "220px",
                // minHeight: "220px",
                overflow: "hidden",
                borderRadius: "0.5rem",
                position: "relative",
              }}
              onMouseEnter={() => swiperRef.current?.autoplay?.stop()}
              onMouseLeave={() => swiperRef.current?.autoplay?.start()}
            >
              {!popupImage && (
                <div
                  className="position-absolute"
                  style={{
                    backgroundColor: "var(--white)",
                    width: "auto",
                    padding: "0 2px 2px 0",
                    zIndex: 2,
                  }}
                >
                  <img
                    style={{ width: "18px" }}
                    src={ad?.profilePhoto || PlaceHolder}
                    alt={ad?.FullName}
                  />
                </div>
              )}
              <Swiper
                modules={[Autoplay]}
                autoplay={{ delay: 1000, disableOnInteraction: false }}
                speed={4000}
                loop={images.length > 1}
                slidesPerView={1}
                style={{ height: "100%", width: "100%" }}
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                onTouchStart={() => swiperRef.current?.autoplay?.stop()}
                onTouchEnd={() => swiperRef.current?.autoplay?.start()}
              >
                {images.map((img, idx) => (
                  <SwiperSlide
                    key={idx}
                    style={{ height: "100%", width: "100%" }}
                  >
                    <img
                      src={img || PlaceHolder}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = PlaceHolder;
                      }}
                      alt={`scroll-img-${idx}`}
                      loading="lazy"
                      onClick={(e) => {
                        e.stopPropagation();
                        setPopupImage(img);
                      }}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "0.5rem",
                        cursor: "pointer",
                        display: "block",
                      }}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Col>

          <Col lg="7" md="7">
            <CardBody
              onClick={() => handleCardClick(ad)}
              className="lca-card-body"
            >
              <CardTitle
                tag="h5"
                className="mb-2 d-flex flex-row align-items-center gap-2"
                // style={{ fontSize: "large", color: "#3e3d3dff" }}
                style={{
                  fontSize: "large",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                <b>
                  {ad?.Title?.length > 100
                    ? `${ad.Title.substring(0, 100)}...`
                    : ad.Title}
                </b>
                {/* {onlineView && (
                  <span className="mt-1">
                    <OnlineStatus createdBy={ad?.createdBy} />
                  </span>
                )} */}
              </CardTitle>
              <CardText style={{ fontSize: "medium", margin: "0px" }}>
                {ad?.Description?.length > 200
                  ? `${ad.Description.substring(0, 200)}...`
                  : ad.Description}
              </CardText>
              <div>
                <CardText
                  className="text-nowrap m-0"
                  style={{ fontSize: "medium" }}
                >
                  <FontAwesomeIcon icon={faMapMarkerAlt} />
                  <i>
                    {" "}
                    {ad.Zipcode}, {ad?.Location}
                  </i>
                </CardText>
                {ad.categoryName && (
                  <CardText className="fs-6 ">
                    <b>Service Provided: </b>
                    {ad.itemName
                      ? ad.itemName
                      : ad.subCategoryName
                        ? ad.subCategoryName
                        : ad.categoryName}
                  </CardText>
                )}
              </div>
              <div>
                <p className="mb-0 posting" style={{ fontSize: "small" }}>
                  Posting Date/Time:{" "}
                  {formatDate(
                    convertToUserTimezone(ad?.updatedAt).split(" ")[0],
                  )}{" "}
                  {convertTo12HourFormat(
                    convertToUserTimezone(ad?.updatedAt).split(" ")[1],
                  )}
                </p>
              </div>
            </CardBody>
          </Col>
          <Col
            lg="2"
            md="2"
            className="d-flex flex-column align-items-center justify-content-center"
          >
            {user?.UserID != ad.createdBy && (
              <ActionButtons
                card={ad}
                isAdmin={isAdmin}
                phoneButton={phoneButton}
                handleAction={handleAction}
                showMessageButton={showMessageButton}
              />
            )}
          </Col>
        </Row>
      </Card>
      {popupImage && (
        <div
          className="image-popup-overlay"
          onClick={() => setPopupImage(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "var(--overly-bg)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            className="popup-box"
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              backgroundColor: "var(--white)",
              padding: "1rem",
              borderRadius: "0.5rem",
              maxWidth: "80vw",
              maxHeight: "80vh",
              boxShadow: "0 2px 10px var(--theme-shadow)",
            }}
          >
            <button
              onClick={() => setPopupImage(null)}
              style={{
                position: "absolute",
                top: "-10px",
                right: "-2px",
                background: "var(--gold-deep)",
                color: "var(--white)",
                border: "none",
                borderRadius: "50%",
                width: "30px",
                height: "32px",
                fontSize: "20px",
                cursor: "pointer",
              }}
              aria-label="Close image popup"
            >
              ×
            </button>
            <img
              src={popupImage}
              alt="Zoomed"
              style={{
                maxWidth: "100%",
                maxHeight: "65vh",
                objectFit: "contain",
                display: "block",
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default BwvBox;
